module.exports = __webpack_public_path__ + "ptc_nakagawa_A1.6440d935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_A1.jpg
// module id = HgGS
// module chunks = 0